import { Component } from '@angular/core';

@Component({
  selector: 'app-menu-list-item-expander',
  templateUrl: './menu-list-item-expander.component.html',
  styleUrls: ['./menu-list-item-expander.component.scss'],
  standalone: false
})
export class MenuListItemExpanderComponent {
  public open = false;

  public toggle() {
    this.open = !this.open;
  }
}
